import { useTranslation } from '../../i18n/LanguageContext'
import './HeroSubtitle.css'

const HeroSubtitle = () => {
  const { t } = useTranslation()
  return (
    <p className="hero__subtitle">
      {t('hero.subtitle')}
    </p>
  )
}

export default HeroSubtitle
